import { useApiQuery } from '~/hooks';
import { getActivePaymentApi } from '../repository';

export const PAYMENT_QUERY_KEYS = {
  ACTIVE_PAYMENT: 'payment-active',
};

/**
 * Query hook to get active payment
 *
 * @param options - Query options including purpose filter
 */
export const useGetActivePaymentQuery = (options?: {
  enabled?: boolean;
  purpose?: 'wallet' | 'credits';
}) => {
  return useApiQuery({
    queryKey: [PAYMENT_QUERY_KEYS.ACTIVE_PAYMENT, options?.purpose],
    queryFn: () => getActivePaymentApi(options?.purpose),
    enabled: options?.enabled !== false,
    refetchInterval: false, // Don't auto-refetch
    staleTime: 30000, // Consider data stale after 30 seconds
  });
};
